import Handlebars from "handlebars";

Handlebars.registerHelper("any", function (...args) {
  const options = args.pop() ?? {};
  return args.some(Boolean) ? options.fn(this) : options.inverse(this);
});
